"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectIsWidgetAdvanced = exports.selectIsEditing = exports.selectWidgetScheme = exports.selectWidgetConfig = exports.selectFields = exports.selectBasemap = exports.selectBbox = exports.selectBounds = exports.selectLng = exports.selectLat = exports.selectZoom = exports.selectWidget = exports.selectAdvanced = exports.selectDisabledFeatures = void 0;

var _reselect = require("reselect");

var _exposedHooks = require("@widget-editor/widget-editor/lib/exposed-hooks");

var selectDisabledFeatures = function selectDisabledFeatures(state) {
  return state.editor.disabledFeatures;
};

exports.selectDisabledFeatures = selectDisabledFeatures;

var selectAdvanced = function selectAdvanced(state) {
  return state.editor.advanced;
};

exports.selectAdvanced = selectAdvanced;

var selectWidget = function selectWidget(state) {
  return state.editor.widget;
};

exports.selectWidget = selectWidget;

var selectZoom = function selectZoom(state) {
  var _state$editor$map$zoo, _state$editor$map;

  return (_state$editor$map$zoo = (_state$editor$map = state.editor.map) === null || _state$editor$map === void 0 ? void 0 : _state$editor$map.zoom) !== null && _state$editor$map$zoo !== void 0 ? _state$editor$map$zoo : null;
};

exports.selectZoom = selectZoom;

var selectLat = function selectLat(state) {
  var _state$editor$map$lat, _state$editor$map2;

  return (_state$editor$map$lat = (_state$editor$map2 = state.editor.map) === null || _state$editor$map2 === void 0 ? void 0 : _state$editor$map2.lat) !== null && _state$editor$map$lat !== void 0 ? _state$editor$map$lat : null;
};

exports.selectLat = selectLat;

var selectLng = function selectLng(state) {
  var _state$editor$map$lng, _state$editor$map3;

  return (_state$editor$map$lng = (_state$editor$map3 = state.editor.map) === null || _state$editor$map3 === void 0 ? void 0 : _state$editor$map3.lng) !== null && _state$editor$map$lng !== void 0 ? _state$editor$map$lng : null;
};

exports.selectLng = selectLng;

var selectBounds = function selectBounds(state) {
  var _state$editor$map$bou, _state$editor$map4;

  return (_state$editor$map$bou = (_state$editor$map4 = state.editor.map) === null || _state$editor$map4 === void 0 ? void 0 : _state$editor$map4.bounds) !== null && _state$editor$map$bou !== void 0 ? _state$editor$map$bou : null;
};

exports.selectBounds = selectBounds;

var selectBbox = function selectBbox(state) {
  var _state$editor$map$bbo, _state$editor$map5;

  return (_state$editor$map$bbo = (_state$editor$map5 = state.editor.map) === null || _state$editor$map5 === void 0 ? void 0 : _state$editor$map5.bbox) !== null && _state$editor$map$bbo !== void 0 ? _state$editor$map$bbo : null;
};

exports.selectBbox = selectBbox;

var selectBasemap = function selectBasemap(state) {
  var _state$editor$map6;

  return ((_state$editor$map6 = state.editor.map) === null || _state$editor$map6 === void 0 ? void 0 : _state$editor$map6.basemap) ? {
    basemap: state.editor.map.basemap.basemap,
    labels: state.editor.map.basemap.labels || null,
    boundaries: state.editor.map.basemap.boundaries || false
  } : null;
};

exports.selectBasemap = selectBasemap;

var selectFields = function selectFields(state) {
  return state.editor.fields;
};

exports.selectFields = selectFields;
var selectWidgetConfig = (0, _reselect.createSelector)([selectWidget], function (widget) {
  return widget ? widget.attributes.widgetConfig : null;
});
exports.selectWidgetConfig = selectWidgetConfig;
var selectWidgetScheme = (0, _reselect.createSelector)([selectWidgetConfig], function (widgetConfig) {
  return (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.config) ? (0, _exposedHooks.getLocalCache)().adapter.getDeserializedScheme(widgetConfig.config) : null;
});
exports.selectWidgetScheme = selectWidgetScheme;
var selectIsEditing = (0, _reselect.createSelector)([selectWidget], function (widget) {
  return !!widget;
});
exports.selectIsEditing = selectIsEditing;
var selectIsWidgetAdvanced = (0, _reselect.createSelector)([selectWidget], function (widget) {
  var _widget$attributes, _widget$attributes$wi;

  return !!widget && !(widget === null || widget === void 0 ? void 0 : (_widget$attributes = widget.attributes) === null || _widget$attributes === void 0 ? void 0 : (_widget$attributes$wi = _widget$attributes.widgetConfig) === null || _widget$attributes$wi === void 0 ? void 0 : _widget$attributes$wi.paramsConfig);
});
exports.selectIsWidgetAdvanced = selectIsWidgetAdvanced;